import { Injectable } from "@angular/core";

import { EjendomsfaktorDefinitionValgmulighedDto } from "./model/ejendomsfaktor-definition-valgmulighed.dto";
import { EjendomsfaktorDefinitionValgmulighed } from "./model/ejendomsfaktor-definition-valgmulighed.model";
import { EjendomsfaktorDefinitionDto } from "./model/ejendomsfaktor-definition.dto";
import { EjendomsfaktorDefinition } from "./model/ejendomsfaktor-definition.model";

@Injectable({ providedIn: "root" })
export class EjendomsfaktorMapper {
    public dtoToEjendomsfaktorDefinitioner(dto: EjendomsfaktorDefinitionDto[]): EjendomsfaktorDefinition[] {
        const result = dto.map((d) => this.dtoToEjendomsfaktorDefinition(d));
        return result;
    }

    public dtoToEjendomsfaktorDefinition(dto: EjendomsfaktorDefinitionDto): EjendomsfaktorDefinition {
        const result: EjendomsfaktorDefinition = {
            datatype: dto.datatype,
            decimaler: dto.decimaler,
            enhed: dto.enhed,
            id: dto.id,
            maske: dto.maske,
            maxVaerdi: dto.maxVaerdi,
            minVaerdi: dto.minVaerdi,
            navn: dto.navn,
            readonly: dto.readonly,
            valgmuligheder: this.dtoToEjendomsfaktorDefinitionValgmuligheder(dto.valgmuligheder)
        };
        return result;
    }

    public dtoToEjendomsfaktorDefinitionValgmuligheder(
        dto: EjendomsfaktorDefinitionValgmulighedDto[]
    ): EjendomsfaktorDefinitionValgmulighed[] {
        const result = dto.map((d) => this.dtoToEjendomsfaktorDefinitionValgmulighed(d));
        return result;
    }

    public dtoToEjendomsfaktorDefinitionValgmulighed(dto: EjendomsfaktorDefinitionValgmulighedDto): EjendomsfaktorDefinitionValgmulighed {
        const result: EjendomsfaktorDefinitionValgmulighed = {
            id: dto.id,
            navn: dto.navn
        };
        return result;
    }
}
